
<script>

 import { onMount } from 'svelte';
 import { onDestroy } from 'svelte';

 import ColorUtils, { rgbToString, rgbaToString } from './ColorUtils.svelte';

 import {CLIENT_MSG} from '../Enums.svelte';

 import { pickingFromCanvas } from '../stores';

 import { sendMessage } from '../stores';

 import { messageStore } from '../stores';


 // used for messages

 import { brushSize, opacity, currentColor} from '../stores';






 let readyForUpdate = false;

 let colorSelectionPreview;

 let holder;
 let canvas_inst;

 let memory_canvas_inst;

 let ctx;

 let memory_ctx;


 let canvas_in_img;

 let currentWidth = 0;
 let currentHeight = 0;

 onMount(async () => {

        //used for rendering
        ctx = canvas_inst.getContext("2d", {alpha: !1});
        //used for state
        memory_ctx = memory_canvas_inst.getContext("2d", {alpha: !1});

        memory_canvas_inst.width = zoomKeeper.canvas_width;
        memory_canvas_inst.height = zoomKeeper.canvas_height;

        resizeToHolder();


        let requestCanvasState = {
            type: CLIENT_MSG.getCanvasState,
        }

        sendMessage(requestCanvasState);

        readyForUpdate = true;
	});

 export function resizeToHolder(){
    canvas_inst.width  = holder.clientWidth;
    let newHeight = holder.clientWidth / 2;

    currentHeight = newHeight;
    currentWidth = holder.clientWidth;

    canvas_inst.height = newHeight;

    drawCurrentView();
 }

 function drawCurrentView(){
    ctx.clearRect(0,0, currentWidth, currentHeight);
    ctx.fillStyle = "white", ctx.fillRect(0, 0, currentWidth, currentHeight);


    if (canvas_in_img != null){
        ctx.drawImage(memory_canvas_inst, 0, 0, currentWidth, currentHeight);
    }


 }


 let brushTouching = false;

 const color_sub = pickingFromCanvas.subscribe(value => {

    if (readyForUpdate) {

        colorSelectionPreview.style.left = -25 +"px";
        colorSelectionPreview.style.top = -25 +"px";

        if (value == true){
            canvas_inst.style.cursor = "crosshair";
            colorSelectionPreview.style.display = "block";
        }
        else{
            canvas_inst.style.cursor = "default";
            colorSelectionPreview.style.display = "none";
        }
    }
 })



 const prev_pos = {x: 0, y: 0}
 const cur_pos = {x: 0, y: 0}

 function followBrush(event){

    let pos = getPositionOnCanvasWithSize(event);

    prev_pos.x = cur_pos.x;
    prev_pos.y = cur_pos.y;

    cur_pos.x = pos.x;
    cur_pos.y = pos.y;

    getPositionOnCanvasWithSize(event);

    if (brushTouching ){

        let opacityAdjusted = parseFloat($opacity) / 100;

        let strokeMessage = 
        {
            type: CLIENT_MSG.strokeMessage,
            pre_x: prev_pos.x,
            pre_y: prev_pos.y,
            x: cur_pos.x,
            y: cur_pos.y,
            r: $currentColor[0],
            g: $currentColor[1],
            b: $currentColor[2],
            a: opacityAdjusted,
            size: $brushSize
        }

        sendMessage(strokeMessage);

    }
    else if($pickingFromCanvas){

        let pos = getPositionOnCanvas(event)

        colorSelectionPreview.style.left = (event.clientX + 25) +"px";
        colorSelectionPreview.style.top = (event.clientY - 15) +"px";

        let pixel_picked = ctx.getImageData(pos.x, pos.y, 1, 1).data;

        colorSelectionPreview.style.backgroundColor = rgbToString(pixel_picked[0], pixel_picked[1], pixel_picked[2]);
        
    }
 }

 function brushDown(event){
    if ($pickingFromCanvas){
        
        let pos = getPositionOnCanvas(event)

        let pixel_picked = ctx.getImageData(pos.x, pos.y, 1, 1).data;

        currentColor.set([pixel_picked[0], pixel_picked[1], pixel_picked[2]]);

        pickingFromCanvas.set(false);
    }
    else{
        brushTouching = true;
    }
}


function getPositionOnCanvas(event){
    let box = canvas_inst.getBoundingClientRect();

    let x = Math.round(event.clientX - box.left);
    let y = Math.round(event.clientY - box.top);

    return {x: x, y: y}
}

function strokeInCTX(ctx_to_use, msg, align_local){
    ctx_to_use.beginPath();
    ctx_to_use.lineCap = "round";

    let pre_x = msg.pre_x;
    let pre_y = msg.pre_y;

    let x = msg.x;
    let y = msg.y;

    let size = msg.size;

    let colorString = rgbaToString(msg.r, msg.g, msg.b, msg.a);
    ctx_to_use.strokeStyle = colorString;
    ctx_to_use.lineWidth = size;

    ctx_to_use.moveTo(pre_x, pre_y);
    ctx_to_use.lineTo(x, y);
    ctx_to_use.stroke();

}

 function brushUp(event){brushTouching = false;}



 //zooming stuff

 const zoomKeeper = {
    canvas_width: 1512,
    canvas_height: 840,
    x:0,
    y:0,
    x_span:0,
    y_span:0,
    percentage_seen: 100
 }

 function getPositionOnCanvasWithSize(event){
    let box = canvas_inst.getBoundingClientRect();

    let x_width = box.left;
    let y_height = box.top;

    let width_adjusted = zoomKeeper.canvas_width / (box.right - box.left);
    let height_adjusted = zoomKeeper.canvas_height / (box.bottom - box.top);

    let x = (event.clientX - x_width) * width_adjusted;
    let y = (event.clientY - y_height) * height_adjusted;

    return {x: Math.round(x), y: Math.round(y)}
 }

 function handleScroll(event){

    let scrollUp = event.wheelDeltaY;
    if (scrollUp > 0){
        //is positve
        if (zoomKeeper.percentage_seen <= 100){

        }
    }
    else{
        //is negative
        if (zoomKeeper.percentage_seen >= 30){

        }
    }
 }

 //network stuff;

 const messageStore_store = messageStore.subscribe(value => {

    let msg = value;

    if (msg != undefined){


        // console.log(msg);

        switch (msg.type) {
            case CLIENT_MSG.getCanvasState:

                //draws the most recent canvas image
                canvas_in_img = new Image;
                canvas_in_img.onload = function () {
                    memory_ctx.drawImage(canvas_in_img, 0, 0, zoomKeeper.canvas_width, zoomKeeper.canvas_height);
                    drawCurrentView();
                }, canvas_in_img.src = msg.canvas_data;

            break;
            
            case CLIENT_MSG.strokeMessage:

                // strokeInCTX(ctx, msg, true);
                strokeInCTX(memory_ctx, msg, false);
                drawCurrentView();
    
            default:
                break;
        }
    }
    

 });



 function leaveCanvas(event){
    brushTouching = false;
 }



 function touchStart(event){
    let trans_event = event.changedTouches[0];

    let pos = getPositionOnCanvasWithSize(trans_event);

    cur_pos.x = pos.x;
    cur_pos.y = pos.y;

    brushDown(trans_event);
}

 function touchEnd(event){
    let trans_event = event.changedTouches[0];
    brushUp(trans_event);
 }

 function touchMove(event){
    let trans_event = event.changedTouches[0];
    followBrush(trans_event);
 }


 //destroy utils

 
 onDestroy(color_sub);
 onDestroy(messageStore_store);

</script>

<svelte:window 
  on:resize={resizeToHolder} 
  />


<div class="colorPreview" bind:this={colorSelectionPreview}></div>

<div class="canvasHolder" bind:this={holder}>

    <canvas 
    width="1350" 
    height="750" 
    bind:this={canvas_inst}
    on:mousemove={followBrush}
    on:mousedown={brushDown}
    on:mouseup={brushUp}
    on:mouseleave={leaveCanvas} 


    on:touchstart={touchStart}
    on:touchmove={touchMove}
    on:touchend={touchEnd}
    

    on:wheel={handleScroll}
    id="displayCanvas"
    >
    </canvas>


    <canvas 
    id="memoryCanvas"
    width="1" 
    height="1" 
    bind:this={memory_canvas_inst}
    >
    </canvas>

</div>


<style>
    .canvasHolder{
        width: 85%;
    }

    .colorPreview{
        display: none;
        width: 20px;
        height: 20px;
        border: 1px solid black;
        position: fixed;
        left: 0px;
        top: 0px;
        background-color: white;
    }

    #displayCanvas{
        box-sizing: content-box;
    }

    #memoryCanvas{
        display: none;
    }

</style>